export default __webpack_public_path__ + "static/media/HappyBirthday_02.37c9b1e3.png";